import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import AllCategory from '@/assets/images/category/all-category.png';
import { cn } from '@/lib/utils';
import { getFileUrl } from '@/services/CommonService';

const POSCategoriesSlider = ({ dataCategorySource, categoriesSelectedValue, setCategoriesSelectedValue }) => {
    return (
        <div className={`swiper mb-7 menu-swiper`}>
            <Swiper speed={1000} slidesPerView="auto" spaceBetween={16} className="menu-slides" dir="rtl">
                <SwiperSlide key={0} className={cn('!w-fit relative', categoriesSelectedValue === 0 && 'pos-group')}>
                    <button
                        onClick={() => setCategoriesSelectedValue(0)}
                        className={cn(
                            'w-32 flex flex-col items-center text-center gap-4 p-3 rounded-2xl border-b-2 border-transparent transition hover:bg-primary-light bg-[#F7F7FC] overflow-hidden',
                            categoriesSelectedValue === 0 && 'active'
                        )}>
                        <img className="h-10 drop-shadow-category" src={AllCategory} alt="category" />
                        <h3 className="w-full text-xs leading-[16px] whitespace-nowrap overflow-hidden text-ellipsis font-medium font-rubik">{'All Items'}</h3>
                    </button>
                </SwiperSlide>
                {dataCategorySource &&
                    dataCategorySource.length > 0 &&
                    dataCategorySource.map((category, index) => (
                        <SwiperSlide key={category?._id} className={cn('!w-fit relative', categoriesSelectedValue === category?._id && 'pos-group')}>
                            <button
                                onClick={() => setCategoriesSelectedValue(category?._id)}
                                className={cn(
                                    'w-32 flex flex-col items-center text-center gap-4 p-3 rounded-2xl border-b-2 border-transparent transition hover:bg-primary-light bg-[#F7F7FC] overflow-hidden',
                                    categoriesSelectedValue === category?._id && 'active'
                                )}>
                                <img className="h-10 drop-shadow-category" src={getFileUrl(category?.file_name, 'productCategory')} alt="category" />
                                <h3 className="w-full text-xs leading-[16px] whitespace-nowrap overflow-hidden text-ellipsis font-medium font-rubik">{category?.name}</h3>
                            </button>
                        </SwiperSlide>
                    ))}
            </Swiper>
        </div>
    );
};

export default POSCategoriesSlider;
